// extracted by mini-css-extract-plugin
export default {"tooltip-container":"Tooltip_tooltip-container__f5KhV","tooltip":"Tooltip_tooltip__81DDN","fadeout":"Tooltip_fadeout__-hGhd"};